import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import type { Stage } from '@recruitee/stages-types';
import { HeadingComponent } from '@recruitee/user-interface';

import { AnonymousLearnMoreTriggerComponent } from '../anonymous-learn-more/anonymous-learn-more-trigger.component';

@Component({
  selector: 'rt-anonymous-info-bar',
  templateUrl: './anonymous-info-bar.component.html',
  styleUrls: ['./anonymous-info-bar.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeadingComponent, TranslatePipe, AnonymousLearnMoreTriggerComponent],
  host: {
    '[class.no-radius]': 'noRadius()',
  },
})
export class AnonymousInfoBarComponent {
  public anonymousStage = input.required<Stage | null | undefined>();

  public noRadius = input<boolean, boolean | string>(false, { transform: booleanAttribute });
}
